/* ATN Membership - Section 03: The ATN Ecosystem
   Draws a straight line from every node to the edge of the center badge,
   with a dot at each end. Lines are redrawn whenever the layout changes
   (resize, fonts/images loading, theme editor updates). */

(function () {
  'use strict';

  var SVG_NS = 'http://www.w3.org/2000/svg';

  function el(name, attrs) {
    var node = document.createElementNS(SVG_NS, name);
    for (var key in attrs) {
      if (Object.prototype.hasOwnProperty.call(attrs, key)) {
        node.setAttribute(key, attrs[key]);
      }
    }
    return node;
  }

  function ATNEcosystem(root) {
    this.root = root;
    this.grid = root.querySelector('.atn-mem-eco__grid');
    this.svg = root.querySelector('.atn-mem-eco__lines');
    this.badge = root.querySelector('.atn-mem-eco__badge-inner');
    this.groups = [];
    this.raf = null;

    if (!this.grid || !this.svg || !this.badge) return;
    if (!root.classList.contains('atn-mem-eco--radial')) return;

    var self = this;
    this.schedule = function () {
      if (self.raf) return;
      self.raf = window.requestAnimationFrame(function () {
        self.raf = null;
        self.draw();
      });
    };

    if ('ResizeObserver' in window) {
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this.grid);
    }
    window.addEventListener('resize', this.schedule);
    window.addEventListener('load', this.schedule);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(this.schedule);
    }
    this.grid.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', self.schedule, { once: true });
    });

    this.bindHover();
    this.draw();
  }

  ATNEcosystem.prototype.nodes = function () {
    return Array.prototype.slice.call(
      this.grid.querySelectorAll('.atn-mem-eco__col .atn-mem-eco-node')
    );
  };

  ATNEcosystem.prototype.draw = function () {
    var svg = this.svg;
    var self = this;

    while (svg.firstChild) svg.removeChild(svg.firstChild);
    this.groups = [];

    // Hidden on the stacked (single-column) layout
    if (window.getComputedStyle(svg).display === 'none') return;

    var box = this.grid.getBoundingClientRect();
    if (!box.width || !box.height) return;

    svg.setAttribute('viewBox', '0 0 ' + box.width + ' ' + box.height);

    var badge = this.badge.getBoundingClientRect();
    var cx = badge.left + badge.width / 2 - box.left;
    var cy = badge.top + badge.height / 2 - box.top;
    var radius = badge.width / 2;

    this.nodes().forEach(function (node) {
      var isLeft = !!node.closest('.atn-mem-eco__col--left');
      var rect = node.getBoundingClientRect();
      var icon = node.querySelector('.atn-mem-eco-node__icon');
      var iconRect = icon ? icon.getBoundingClientRect() : rect;

      // Start: inner edge of the node, level with the icon
      var sx = (isLeft ? rect.right : rect.left) - box.left;
      var sy = iconRect.top + iconRect.height / 2 - box.top;

      // End: point on the badge ring facing the node
      var dx = sx - cx;
      var dy = sy - cy;
      var len = Math.sqrt(dx * dx + dy * dy) || 1;
      var ex = cx + (dx / len) * radius;
      var ey = cy + (dy / len) * radius;

      var group = el('g', { class: 'atn-mem-eco__link' });
      group.appendChild(el('line', {
        class: 'atn-mem-eco__line',
        x1: sx.toFixed(1), y1: sy.toFixed(1),
        x2: ex.toFixed(1), y2: ey.toFixed(1)
      }));
      group.appendChild(el('circle', {
        class: 'atn-mem-eco__dot atn-mem-eco__dot--start',
        cx: sx.toFixed(1), cy: sy.toFixed(1), r: 4.5
      }));
      group.appendChild(el('circle', {
        class: 'atn-mem-eco__dot atn-mem-eco__dot--end',
        cx: ex.toFixed(1), cy: ey.toFixed(1), r: 3.5
      }));

      svg.appendChild(group);
      self.groups.push(group);
    });
  };

  ATNEcosystem.prototype.bindHover = function () {
    var self = this;
    this.nodes().forEach(function (node, index) {
      var on = function () {
        if (self.groups[index]) self.groups[index].classList.add('is-active');
      };
      var off = function () {
        if (self.groups[index]) self.groups[index].classList.remove('is-active');
      };
      node.addEventListener('mouseenter', on);
      node.addEventListener('mouseleave', off);
      node.addEventListener('focusin', on);
      node.addEventListener('focusout', off);
    });
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-atn-eco]').forEach(function (root) {
      if (root.dataset.atnEcoBound === 'true') return;
      root.dataset.atnEcoBound = 'true';
      new ATNEcosystem(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();